import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @typedef {import('types').Bookmark} BookmarkModel
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { getMyBookmarks, getBookmarkByReference, createBookmark, deleteBookmark } from 'actions/bookmarks';
import { Button, Icon } from '@haldor/ui';
import './_Bookmark.scss';
/**
 * @prop {number} referenceId
 * @prop {string} referenceType
 */

var Bookmark = /*#__PURE__*/function (_Component) {
  _inherits(Bookmark, _Component);

  var _super = _createSuper(Bookmark);

  function Bookmark(props) {
    var _this;

    _classCallCheck(this, Bookmark);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.referenceType == null || _this.props.referenceId == null) {
        return false;
      }

      if (_this.props.bookmarks == null || _this.props.bookmarks.length == 0) {
        _this.props.getMyBookmarks().then(function () {
          _this.setState({
            loading: false
          });
        });
      } else {
        _this.setState({
          loading: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onBookmarkClick", function () {
      var _this$props = _this.props,
          bookmarks = _this$props.bookmarks,
          referenceType = _this$props.referenceType,
          referenceId = _this$props.referenceId;
      /**
       * @type {BookmarkModel} bookmark
       */

      var bookmark = bookmarks.find(function (bookmark) {
        return bookmark.referenceType == referenceType && bookmark.referenceId == referenceId;
      });

      if (bookmark != null) {
        // delete bookmark
        _this.props.deleteBookmark(bookmark.id);
      } else {
        _this.props.createBookmark([{
          referenceType: referenceType,
          referenceId: referenceId
        }]);
      }
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(Bookmark, [{
    key: "render",
    value: function render() {
      if (this.props.referenceType == null || this.props.referenceId == null) {
        return null;
      }

      if (this.state.loading) {
        return null;
      }

      var _this$props2 = this.props,
          bookmarks = _this$props2.bookmarks,
          referenceId = _this$props2.referenceId,
          referenceType = _this$props2.referenceType;
      /**
       * @type {BookmarkModel} bookmark
       */

      var bookmark = bookmarks.find(function (bookmark) {
        return bookmark.referenceType == referenceType && bookmark.referenceId == referenceId;
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "bookmarks bookmark--toggle",
        onClick: this.onBookmarkClick
      }, bookmark == null ? /*#__PURE__*/React.createElement(Icon, {
        name: "Star",
        bw: true
      }) : /*#__PURE__*/React.createElement(Icon, {
        name: "Star_Fill"
      }));
    }
  }]);

  return Bookmark;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    bookmarks: state.Bookmarks.user
  };
}

export default connect(mapStateToProps, {
  getMyBookmarks: getMyBookmarks,
  getBookmarkByReference: getBookmarkByReference,
  createBookmark: createBookmark,
  deleteBookmark: deleteBookmark
})(Bookmark);